import { Outlet } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { MDSLogo } from '@marqvision/mds-v2';
import { Footer } from '@marqvision/shared';
import 'react-toastify/dist/ReactToastify.css';
import { LeftPromotion } from '~/components/User/LeftPromotion';

const useStyles = makeStyles(({ color }) => ({
  wrapper: {
    minHeight: '100%',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    backgroundColor: color.bg.surface.neutral.default.normal,
  },
  main: {
    position: 'relative',
    paddingTop: '64px',
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  content: {
    padding: '24px',
    display: 'grid',
    placeContent: 'center',
  },
  logo: {
    padding: '0',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
}));

export const AuthLayout = () => {
  const classes = useStyles();

  const handleLogoClick = () => {
    window.location.href = 'https://www.marqvision.com';
  };

  return (
    <div className={classes.wrapper}>
      <aside>{['ko', 'ko-KR'].includes(window.navigator.language) ? <LeftPromotion /> : undefined}</aside>
      <main className={classes.main}>
        <button onClick={handleLogoClick} className={classes.logo}>
          <MDSLogo logoType="ai" size={32} color="black" />
        </button>
        <div className={classes.content}>
          <Outlet />
        </div>
        <Footer />
      </main>
    </div>
  );
};
